// extracted by mini-css-extract-plugin
module.exports = {"chart":"Charts_chart__3dpLE","bar":"Charts_bar__S4wNq"};